// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getCreditMemos} from '../../../shared/repositories';
import {getFileName} from '../../../shared/services/get-file-name';
import {openFile} from '../../../shared/services/open-file';

export const readCreditMemos = (memos, language) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const memoNumbers = memos.map(memo => memo.creditMemoNumber);

        try {

            const response = await getCreditMemos(memoNumbers, language);

            const fileName = getFileName(response);

            const blob = await response.blob();

            openFile(blob, fileName, 'application/pdf');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/credit-memo/action-creators/read-credit-memos.js